import React, { Component } from "react";
import RadioBtnGroup from "@components/RadioBtnGroup";
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { DatePicker } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY/MM/DD";

export default class DateGroup extends Component {
  state = {
    start: null,
    end: null,
  };

  componentDidMount() {
    // 是否默认选中值
    const { defaultInit = true } = this.props;
    if (defaultInit) {
      this.handleSelectBtnsToDate(this.props.defaultValue);
    }
  }

  onChange = (date, dateString) => {
    this.setState(
      {
        defaultValue: "",
        end:
          dateString[0].length === 0 ? null : moment(dateString[0], dateFormat),
        start:
          dateString[1].length === 0 ? null : moment(dateString[1], dateFormat),
      },
      () => {
        this.props.onDateChange(this.getTimestamp(), "");
      }
    );
  };

  handleDisabledDate = (currentDate) => {
    const nowTime = moment(new Date())
      .startOf("day")
      .valueOf();
    const currentTime = moment(currentDate)
      .startOf("day")
      .valueOf();
    const { isDeducted } = this.props;

    if (isDeducted && nowTime === currentTime) {
      return true;
    }

    if (this.props.min && currentTime < this.props.min.valueOf()) {
      return true;
    }
    if (this.props.max && currentTime > this.props.max.valueOf()) {
      return true;
    }

    // 如果没有设置 max，默认不允许选择未来日期
    if (!this.props.max && currentTime > nowTime) {
      return true;
    }

    return false;
  };

  handleSelectBtnsToDate = (time) => {
    if (time === "") {
      this.setState({ start: null, end: null });
      return;
    }

    let startday = 0;
    let endday = time === "anytime" ? 0 : Number(time);

    if (time !== "anytime" && Number(time) === -1) {
      startday = Number(time);
      endday = Number(time);
    }

    let start = moment(new Date()).add(startday, "days");
    let end = moment(new Date()).add(endday, "days");

    // start 是较近的日期，end 是较早的日期
    // min/max 限制需要同时应用到两个日期
    if (this.props.min) {
      if (end.valueOf() < this.props.min.valueOf()) {
        end = this.props.min.clone();
      }
      if (start.valueOf() < this.props.min.valueOf()) {
        start = this.props.min.clone();
      }
    }
    if (this.props.max) {
      if (start.valueOf() > this.props.max.valueOf()) {
        start = this.props.max.clone();
      }
      if (end.valueOf() > this.props.max.valueOf()) {
        end = this.props.max.clone();
      }
    }

    this.setState(
      {
        start: start,
        end: end,
      },
      () => {
        this.props.onDateChange(this.getTimestamp(), time);
      }
    );
  };

  handleRadioBtnGroupChange = (data) => {
    this.setState({ defaultValue: data });
    this.handleSelectBtnsToDate(data);
  };

  // 根据 min/max 过滤快捷按钮
  getFilteredBtns = () => {
    const { btns = [], min, max } = this.props;
    const nowTime = moment(new Date()).startOf("day").valueOf();

    return btns.filter((btn) => {
      const time = btn.key;
      if (time === "" || time === "anytime") {
        return true;
      }

      let startday = 0;
      let endday = Number(time);

      if (Number(time) === -1) {
        startday = -1;
        endday = -1;
      }

      const startDate = moment(new Date()).add(startday, "days").startOf("day");
      const endDate = moment(new Date()).add(endday, "days").startOf("day");

      // 如果整个日期范围都在 min 之前，过滤掉
      if (min && startDate.valueOf() < min.valueOf() && endDate.valueOf() < min.valueOf()) {
        return false;
      }

      // 如果整个日期范围都在 max 之后，过滤掉
      if (max && startDate.valueOf() > max.valueOf() && endDate.valueOf() > max.valueOf()) {
        return false;
      }

      // 如果没有设置 max，检查是否都是未来日期
      if (!max && startDate.valueOf() > nowTime && endDate.valueOf() > nowTime) {
        return false;
      }

      return true;
    });
  };

  getTimestamp = () => {
    const start = this.state.start && this.state.start.format(dateFormat);
    const end = this.state.end && this.state.end.format(dateFormat);
    // const time = {
    //     start: new Date(start).getTime() / 1000,
    //     end: new Date(end).getTime() / 1000
    // }
    const time = {
      end: (new Date(start).getTime() + 3600 * 24 * 1000) / 1000,
      start: new Date(end).getTime() / 1000,
    };

    return time;
  };

  render() {
    const value = this.props.defaultValue;
    const filteredBtns = this.getFilteredBtns();
    const usedLocale = this.props.locale || locale;

    return (
      <div style={{ overflow: "hidden" }}>
        <div style={{ float: "left" }}>
          <RadioBtnGroup
            onChange={this.handleRadioBtnGroupChange}
            defaultValue={value}
            btns={filteredBtns}
          />
        </div>
        <div style={{ float: "left", marginLeft: 8 }}>
          <RangePicker
            locale={usedLocale}
            style={{ marginTop: 18 }}
            value={[this.state.end, this.state.start]}
            format={dateFormat}
            onChange={this.onChange}
            disabledDate={this.handleDisabledDate}
          />
        </div>
      </div>
    );
  }
}

